import { faEnvelope, faMapMarkerAlt, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './footer.css';
import Logo from '../images/logo.png';



function Footer() {
  return<>  
  <div className='footer_container' id="contactus">  
    <div className="footer_area">  
         <div className="footer_company_container">
             <div>
              <img  src={Logo} alt="footer Logo" className='footer_logo_icon' onClick={()=> window.open("/","_self")}/>
             </div>
    
              <div>
                  <div className='footer_logo_title'>Land Promoters &</div>
                  <div className='footer_logo_subtitle'>Construction company</div>
              </div>
              </div>

              <div className='stay_connect'>
                  <h6>Social media</h6>
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/profile.php?id=100079113271137">Facebook</a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/spspromoters/">Instagram</a>
                    </li>
                    <li>
                      <a href="https://twitter.com/sps_promoters">Twitter</a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/channel/UCl1wSuB7aNnQQ9Kj_Ovuiwg">Youtube</a>
                    </li>
                  </ul>
              </div>

              <div className='stay_connect'>
                  <h6>Stay connect</h6>
                  <ul>
                    <li>
                      <FontAwesomeIcon icon={faPhoneAlt} className='footer_contact_icon'/>
                      <a href="tel:+919092423735">+91 9092423735</a>
                    </li>
                    <li>
                      <FontAwesomeIcon icon={faEnvelope} className='footer_contact_icon company_mail'/>
                      <a href="mailto:spspromoters2021@gmail.com" className="company_mail">
                      spspromoters2021@gmail.com
                      </a>
                    </li>
                     
                    <li>
                      <FontAwesomeIcon icon={faMapMarkerAlt} className='footer_contact_icon' />
                      <a href="#">10D/31, Minnarsu Nagar, Muthuthevanpatti, veerapandi, theni.</a>
                    </li>
                  </ul>
              </div>
         
  </div>
     <hr className='footer_line' />
     <div className='footer_copyright'>
        <div>
          copyright &copy; 2022 @ spslandpromoterstheni.web.app
        </div>
        <div>
          All rights received
         </div> 
     </div>
  </div>
  </>
 ;
}

export default Footer;

